import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, JSX } from "react";
import type { VideoBlock } from '../types';
import styles from './Video.module.css';
interface VideoProps {
  block: VideoBlock;
  blockId: string;
}
export function Video(t0) {
  const $ = _c(22);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block) {
    t1 = buildSrc(block);
    $[0] = block;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const src = t1;
  let t2;
  if ($[2] !== block.height || $[3] !== block.width) {
    t2 = block.width && block.height ? {
      maxWidth: `${block.width}px`,
      aspectRatio: `${block.width} / ${block.height}`
    } : undefined;
    $[2] = block.height;
    $[3] = block.width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const wrapperStyle = t2;
  if (block.provider === "html5") {
    let t3;
    if ($[5] !== block.title || $[6] !== src) {
      t3 = <video src={src} title={block.title} controls={true} className={styles.video} preload="metadata" />;
      $[5] = block.title;
      $[6] = src;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== blockId || $[9] !== t3 || $[10] !== wrapperStyle) {
      t4 = <div className={styles.wrapper} style={wrapperStyle} data-cms-block-id={blockId} data-cms-field="video">{t3}</div>;
      $[8] = blockId;
      $[9] = t3;
      $[10] = wrapperStyle;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t3;
  if ($[12] !== block.height || $[13] !== block.title || $[14] !== block.width || $[15] !== src) {
    t3 = <iframe src={src} title={block.title} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} width={block.width} height={block.height} className={styles.iframe} />;
    $[12] = block.height;
    $[13] = block.title;
    $[14] = block.width;
    $[15] = src;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== block.provider || $[18] !== blockId || $[19] !== t3 || $[20] !== wrapperStyle) {
    t4 = <div className={styles.wrapper} style={wrapperStyle} data-cms-block-id={blockId} data-cms-field="video" data-provider={block.provider}>{t3}</div>;
    $[17] = block.provider;
    $[18] = blockId;
    $[19] = t3;
    $[20] = wrapperStyle;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}
function buildSrc(block: VideoBlock): string {
  switch (block.provider) {
    case 'youtube':
      return `https://www.youtube.com/embed/${block.videoId}`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${block.videoId}`;
    case 'html5':
    default:
      return block.videoId;
  }
}